// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1MG6v","head":"ProcedureTableInfo_head__3T1-a"};